import { render, staticRenderFns } from "./MyTables.vue?vue&type=template&id=58f4cd4c&scoped=true&"
import script from "./MyTables.vue?vue&type=script&lang=js&"
export * from "./MyTables.vue?vue&type=script&lang=js&"
import style0 from "./MyTables.vue?vue&type=style&index=0&id=58f4cd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4cd4c",
  null
  
)

export default component.exports